import { AgentCommands, UsedCommandType } from '~/constants/commands'
import { isAgentInternalStatus } from '~/constants/task-status'
import { AgentTaskStatus } from '~/protos/agents'
import { useConversationMetadata } from '../conversation'
import { useTaskObj } from './useTaskObj'
import { useTaskStatus } from './useTaskStatus'
import { useTerminatedStatus } from './useTerminatedStatus'

export function useTaskProgress() {
  const task = useTaskObj()
  const taskStatus = useTaskStatus()
  const { command } = useConversationMetadata()
  const isTerminatedStatus = useTerminatedStatus(taskStatus)

  if (isTerminatedStatus) {
    return 100
  }

  if (AgentTaskStatus.DOCUMENT_UPDATED === taskStatus) {
    return 50
  }

  const { steps } = AgentCommands[command as UsedCommandType]
  const responses = task?.details?.orderedStateResponses
  if (Array.isArray(responses)) {
    const uniqueStatuses = new Set(
      responses.map(response => {
        if (isAgentInternalStatus(response.taskStatus)) {
          const { agentInternalStatus } = response.response[0].responseContentStream!
          return `${response.taskStatus}:${agentInternalStatus}`
        }
        return response.taskStatus
      })
    )

    if (uniqueStatuses.size > steps.length) {
      return 99
    }
    return Math.ceil((uniqueStatuses.size / steps.length) * 100)
  }
  return 0
}
